import { render, staticRenderFns } from "./Logisticians.vue?vue&type=template&id=0f7691c7&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7691c7",
  null
  
)

export default component.exports